// Kubix JS overrides (companion to app-overrides.css).
// Desktop PDP uses two fixed-height overflow panes; Chrome won't chain out of a nested
// scroller at its boundary, so forward over-scroll to the page once a pane hits top/bottom.
(function () {
  var PANES = ['.product-image-container', '.product-information'];
  var scroller = document.scrollingElement || document.documentElement;

  function onWheel(event) {
    var pane = event.currentTarget;

    // Only intervene when the pane is genuinely an internal scroller (desktop/tablet layout).
    if (pane.scrollHeight <= pane.clientHeight) return;

    // Vertical intent only, so horizontal trackpad gestures still reach the slider.
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

    var atTop = pane.scrollTop <= 0;
    var atBottom = pane.scrollTop + pane.clientHeight >= pane.scrollHeight - 1;

    if ((event.deltaY > 0 && atBottom) || (event.deltaY < 0 && atTop)) {
      event.preventDefault();
      // 'instant' so the forwarded delta ignores the theme's smooth scroll-behavior and stays native-feeling.
      scroller.scrollBy({ top: event.deltaY, behavior: 'instant' });
    }
  }

  PANES.forEach(function (selector) {
    var pane = document.querySelector(selector);
    if (pane) pane.addEventListener('wheel', onWheel, { passive: false });
  });
})();
